import { useEffect, useState } from 'react'
import { fetchEmployeeDetails, selectEmployeeData } from '../../Redux/Slices/EmployeeListSlice';
import EmployeeListService from '../../services/EmployeeListService';
import { useDispatch, useSelector } from "react-redux";
import {
  showToast,
  TOAST_TYPE,
  DKButton,
  showLoader,
  removeLoader,
  DKIcons,
  DKLabel,
  DKIcon,
  PieChart,
  DKCheckMark,
  showAlert,
  DKTooltipWrapper,
} from "deskera-ui-library";
import RouteManager, { PAGE_ROUTES } from '../../managers/RouteManager';
import Table from '../../services/table';
import Utility, { removeDelayedLoader, showDelayedLoader } from '../../utility/Utility';
import { CONSTANTS, FORMAT, NONE_OPTION } from '../../constants/Constant';
import FormatCurrency from '../../SharedComponents/FormatCurrency';
import PDF_ICON from "../../assets/file/PDF.svg"
import AttachmentService from '../../services/AttachmentService';
import { saveAs } from 'file-saver';
import { selectBenefits, fetchTotalBenefits } from '../../Redux/Slices/BenefitSlice';
import { selectComponent, fetchTotalComponents } from "../../Redux/Slices/ComponentListSlice"
import TerminationPortal from './TerminationPortal';
import { TABLES } from '../../managers/TableManger';
import PayStubList from '../payroll/PayStubList';
import { TENANT, TenantService } from '../../managers/TenantManagerService';
import { useTranslation } from "react-i18next";
import ic_info_message from "../../assets/icons/ic_info_gray01.png";
import { getIncompleteFieldName } from '../../managers/common/CommonUtil';
import { isMobileWebView } from '../../utility/ViewportSizeUtils';
import MaskInputUtil from '../../SharedComponents/MaskInput/MaskInputUtil';
import { fetchShifts, selectShifts } from "../../Redux/Slices/ShiftManagementSlice";
import ShiftUtils from '../shift_management/ShiftUtils';
import ShiftManagementService from '../../services/ShiftManagementService';
import SetupDetails from '../common/Dashboard/SetupDetails';
import { EMPLOYEE } from '../../managers/common/RouteAuth';
import TeamAttendanceCard from '../common/Dashboard/TeamAttendanceCard';
import PermissionUtils, { ACTION, MODULE } from '../user-permissions/PermissionUtils';
import { getCompensation, getMasked } from '../configs/config';
import { selectModuleAccessControl } from '../../Redux/Slices/ModuleAccessControlSlice';
import { isModuleRestricted, MODULE_ACCESS } from '../module-access-control/ModuleAccessControlConstants';

const ViewEmployee = (props) => {
    const { t, i18n } = useTranslation();

    const query = props.location && props.location.search ? new URLSearchParams(props.location.search) : "";
    let userId = query && query.get("id") ? query.get("id") : "";

    const isAdmin = TenantService.get(TENANT.IS_ADMIN);

    const dispatch = useDispatch();
    const employeeDetails = useSelector(selectEmployeeData);
    const componentMeta = useSelector(selectComponent); //
    const benefitsMeta = useSelector(selectBenefits);
    const shifts = useSelector(selectShifts);
    const moduleAccessControl = useSelector(selectModuleAccessControl);

    const [employeeUserId, setEmployeUserId] = useState(userId);

    const [hideListPicker, setHideListPicker] = useState(false);

    const [recentPayStubData, setRecentPayStubData] = useState({})

    const [payStubData, setPayStubData] = useState({})

    const [chartData, setChartData] = useState({})

    const [isTerminateEmployee, setIsTerminateEmployee] = useState(false)
    const [reportingManager, setReportingManager] = useState(NONE_OPTION.name);

    const [mask, setMask] = useState(MaskInputUtil.MASK_STATE);
    const maskUnmaskObservable = ((PermissionUtils.hasAccess(MODULE.SALARY, [ACTION.VIEW, ACTION.EDIT]) || (userId == TenantService.get(TENANT.USER_ID) || Utility.isEmpty(userId))) ) ? MaskInputUtil.subscripeToMaskUnmaskObservable((mask) => {
        setMask(mask);
    }) : null;

    const [isShiftManagementEnabled, setEnableShiftManagement] = useState(TenantService.get(TENANT.IS_SHIFT_MANAGEMENT_ENABLED));
    const [shiftDetails, setShiftDetails] = useState({});
    const [isManager, setIsManager] = useState(TenantService.get(TENANT.IS_MANAGER))
    const list = [
        {
            action: "EDIT",
            title: "Edit",
            icon: DKIcons.ic_edit
        },
        {
            action: "DELETE",
            title: "Delete",
            icon: DKIcons.ic_delete
        },
        {
            action: "TERMINATE",
            title: "Terminate Employee",
            icon: DKIcons.ic_close
        }
    ];

    const [filteredOptions, setFilteredOptions] = useState([]);

    const deleteConfirm = () => [
        {
            title: "Cancel",
            className: "bg-gray1 border-m",
        },
        {
            title: "Delete",
            className: "bg-red text-white ml-r",
            onClick: () => deleteRecord(),
        },
    ];


    useEffect(() => {
        if (Utility.isEmpty(userId)) {
            let tenantData = TenantService.getData()
            userId = tenantData['USER_ID'];
            setEmployeUserId(userId);
        }
        RouteManager.setPresenter({ props: props });

        loadEmployeeDetails()
        let param = {
            "limit": 5,
            "currentPage": 1,
            "sortField": "createdAt",
            "sortOrder": "desc"
        }
        getPayStubData(param);
        loadComponents();
        loadBenefits();
        if (isShiftManagementEnabled) {
            getShifts();
        }

        return () => {
            if(maskUnmaskObservable) {
                MaskInputUtil.unsubscribe(maskUnmaskObservable);
            }
        }
    }, []);

    useEffect(() => {
        if(!Utility.isEmpty(shifts) && !Utility.isEmpty(employeeUserId)) {
            const userShift = ShiftUtils.getShiftByUserId(employeeUserId, shifts);
            setShiftDetails(userShift);
        }
    },[shifts, employeeUserId])

    useEffect(() => {
        if (employeeDetails?.user?.reportingManagerName) {
            setReportingManager(employeeDetails.user.reportingManagerName);
        } else {
            setReportingManager(!TenantService.get(TENANT.CUSTOM_FIELD_SECTION_ENABLED) ? NONE_OPTION.name : "");
        }

        setFilteredOptions(getFilteredOptions(list));
    }, [employeeDetails]);

    const loadComponents = async (config) => {
        try {
            await dispatch(fetchTotalComponents());
        } catch (err) {
            console.error("Error loading components: ", err);
        }
    };

    const loadBenefits = async (config) => {
        try {
            await dispatch(fetchTotalBenefits());
        } catch (err) {
            console.error("Error loading benefits: ", err);
        }
    };

    const loadEmployeeDetails = async () => {
        const timeout = showDelayedLoader();
        try {
            const config = {
                ...EmployeeListService.apiConfig,
                getComponents: true,
                getCompliance: true,
                getBenefits: true,
                customFieldModule: "employee",
            };
            EmployeeListService.apiConfig = config;
            await dispatch(fetchEmployeeDetails(userId));
        } catch (err) {
            console.error("Error loading tenant data: ", err);
        }
        removeDelayedLoader(timeout);
    };

    const getPayStubData = (param) => {
        Table.getPayStub(userId, param).then(
            (response) => {
                getRecentPayStub(response)
                setPayStubData(response)
            },
            (error) => {
                console.log(error)
            }
        )
    }

    const getFilteredOptions = (list) => {
        return list.filter((option) => {
            switch (option.action) {
                case "EDIT":
                    return PermissionUtils.hasAccess(MODULE.EMPLOYEE, [ACTION.EDIT]);
                case "DELETE":
                    return PermissionUtils.hasAccess(MODULE.EMPLOYEE, [ACTION.DELETE]);
                case "TERMINATE":
                    return PermissionUtils.hasAccess(MODULE.EMPLOYEE, [ACTION.EDIT]);
                default:
                    return true;
            }
        });
    }

    const getRecentPayStub = (payStubs) => {
        var recentPaystub
        if (payStubs?.paystubs) {
            payStubs.paystubs.forEach(p => {
                if (Utility.isEmpty(recentPaystub)) {
                    recentPaystub = p
                }
                if (Date.parse(recentPaystub.createdAt) < Date.parse(p.createdAt)) {
                    recentPaystub = p
                }
            });
            setRecentPayStubData(recentPaystub)


        }
        let chart = [
            {
                "title": "Gross Pay",
                "value": recentPaystub ? (recentPaystub['basicPayrun'] ? recentPaystub['basicPayrun'] : 0) + (recentPaystub['basicPayrun'] ? recentPaystub['earnings'] : 0) : 0,
                "color": "#005FCC"
            }, {
                "title": "Taxes",
                "value": recentPaystub && recentPaystub['netTaxes'] ? recentPaystub['netTaxes'] : 0,
                "color": "#00B0FF"
            }, {
                "title": "Deduction",
                "value": (recentPaystub && recentPaystub['deductions'] ? recentPaystub['deductions'] : 0) - (recentPaystub && recentPaystub['netTaxes'] ? recentPaystub['netTaxes'] : 0),
                "color": "#1AAF5D"
            }
        ]
        setChartData(chart)
    }

    const getShifts = async () => {
        const timeout = showDelayedLoader();
        await dispatch(fetchShifts());
        removeDelayedLoader(timeout);
    }

    const getStatus = () => {
        if(!TenantService.get(TENANT.IS_ADMIN)) {
            TenantService.set(TENANT.USER_STATUS,employeeDetails.user.status)
        }
        return (
            <div className="row flex-wrap">
                <div className={`row fs-m  pt-xs pb-xs pl-s pr-s ml-l mr-l border-radius-s ${employeeDetails.user.status === "active" ? `data-grid-badge-color-6` : `data-grid-badge-color-4`}  `} style={{ width: "auto" }}>
                    <div className=" fs-r text-align-left  display-block " style={{ overflowWrap: "break-word" }}>{employeeDetails.user.status === "active" ? "Active" : "Inactive"}</div>
                </div>
            </div>
        )
    }

    const getIncompleteBadge = () => {
        return (
            <div className="row flex-wrap">
                <div className={`row fs-m  pt-xs pb-xs pl-s pr-s border-radius-s data-grid-badge-color-4`} style={{ width: "auto" }}>
                    <div className=" fs-r text-align-left display-block " style={{ overflowWrap: "break-word" }}>{"Incomplete Profile"}</div>
                </div>
            </div>
        )
    }


    const getCompBenefitLabel = (obj) => {
        return (
            <div className="row flex-wrap">
                <div className={`row fs-m  pt-xs pb-xs pl-s pr-s mr-l border-radius-s ${obj.type === "Benefit" ? `data-grid-badge-color-12` : obj.type === "Deduction" ? `data-grid-badge-color-4` : `data-grid-badge-color-6`}`} style={{ width: "auto" }}>
                    {/* <div className=" fs-r text-align-left  display-block " style={{ overflowWrap: "break-word" }}>{obj.type}</div> */}
                    <DKLabel text={obj.type} className="fs-r text-align-left  display-block" />

                </div>
            </div>
        )
    }



    const hideAddNewList = () => {
        setHideListPicker(false)
    }

    const toggleAddNewList = () => {
        setHideListPicker(!hideListPicker)
    };

    const onEditEmployee = () => {
        RouteManager.navigateToPage(
            PAGE_ROUTES.EMPLOYEE_DETAILS,
            `&id=${employeeDetails["user"].userId}&isEdit=true&step=0`
        );
    }

    const deleteRecord = (data) => {
        const parameter = { ids: [employeeDetails["user"].userId] };
        Table.deleteEmployee(parameter).then((data) => {
            showToast("Record Deleted Successfully", TOAST_TYPE.SUCCESS);
            RouteManager.navigateToPage(
                "/employee/",
                `&id=${employeeDetails["user"].userId}&isEdit=true&step=0`
            );
        })
    }

    const onDeleteEmployee = () => {
        showAlert(
            "Delete Record?",
            "Are you sure you want to delete this record? This action cannot be undone later.",
            deleteConfirm()
        );
    }

    const onTerminateEmployee = () => {
        setIsTerminateEmployee(true)
    }

    const loadEmployee = async () => {
        EmployeeListService.apiConfig = {};
        onTerminateEmployeeClose()
        await loadEmployeeDetails();
    }

    const onTerminateEmployeeClose = () => {
        setIsTerminateEmployee(false)
        setHideListPicker(false)
    }

    const routeToShiftDetails = (userShift) => {
        ShiftManagementService.SHIFT = userShift;
        ShiftManagementService.IS_SHIFT_VIEW = true;
        ShiftManagementService.SELECTED_SHIFT_USER_ID = userId;
        RouteManager.navigateToPage(`${PAGE_ROUTES.ADD_SHIFT}?id=${shiftDetails?.id}&isViewMode=true`)
    }

    const getAddNewList = () => {
        return (
            <div
                className="column bg-white border-radius-s border-m shadow-m position-absolute pb-s"
                style={{ top: 40, right: -20, width: 200, zIndex: 9999 }}
            >
                {filteredOptions.map((obj, index) => {
                    if (((employeeDetails["user"].roles.filter(role => role.name === "ADMIN")).length > 0 || employeeDetails["user"].isTerminated) && (obj.title === "Terminate Employee" || obj.title === "Delete")) {
                        return false
                    }
                    if(obj.title === "Terminate Employee" && employeeDetails["user"]?.status === CONSTANTS.DRAFT) {
                        return false
                    }
                    if (employeeDetails["user"].terminationStage === "termination_initiated" && obj.title === "Terminate Employee") {
                        obj.title = "Manage Termination"
                    }
                    if( !isAdmin && obj.title != "Edit"){
                        return
                    }
                    return (
                        <div
                            className="row listPickerBG cursor-hand parent-width border-box"
                            style={{ padding: 12 }}
                            onClick={() => {
                                switch (obj.action) {
                                    case "EDIT":
                                        onEditEmployee();
                                        break;
                                    case "DELETE":
                                        onDeleteEmployee();
                                        break;
                                    case "TERMINATE":
                                        onTerminateEmployee();
                                        break;
                                    default:
                                        break;
                                }
                            }}
                        >
                            <DKIcon src={obj.icon} className="ic-s" />
                            <DKLabel text={obj.title} className="ml-r" />
                        </div>
                    );
                })}
            </div>
        )
    }

    const getIncompleteTooltipText = (incompleteDetails) => {
        let tooltipText = ""
        if(!Utility.isEmpty(incompleteDetails)) {
            tooltipText = `<div><div class='fw-m' style='justify-content:flex-start; padding-top:3px;'>Employee missing fields:</div>${incompleteDetails
              .map(
                (f, i) =>
                  `<div class='d-flex fs-s' style='justify-content:flex-start; padding-top:3px'>${
                    i + 1
                  }. ${getIncompleteFieldName(f)}</div>`
              )
              .join(
                ""
              )}</div><div class='' style='justify-content:flex-start; padding-top:3px;'>Please click on <b>Manage Profile</b> to fill the details</div>`;
        }
        return tooltipText;
    }

    const getEmployeeDetails = () => {
        if (employeeDetails && employeeDetails.user) {
            let name = `${employeeDetails.user.firstName} ${employeeDetails.user.lastName}`
            const compensation = getCompensation(mask, employeeDetails.user);

            return (
              <div className="bg-white p-xl border-radius-m border-m row">
                <div className="column parent-width">
                  <div className="row mb-m">
                    <div className="column">
                      <DKLabel text={name} className="fw-m fs-m mb-s " />
                      <DKLabel
                        text={employeeDetails.user.designation}
                        className=" mb-s"
                      />
                    </div>
                    <div className="column align-self-start">{getStatus()}</div>
                    {!isAdmin && employeeDetails.user.isInCompleteProfile && (
                      <>
                        {/* <div> */}
                        <div className="column align-self-start">
                          {getIncompleteBadge()}
                        </div>
                        {/* <DKTooltipWrapper
                              content={"Hello"}
                              tooltipClassName="warning-tooltip-prop warning-tooltip-prop "
                            >
                              <DKIcon
                                src={ic_info_message}
                                className="ml-s ic-s ml-r mt-xs cursor-hand "
                                style={{ opacity: 0.4 }}
                              />
                            </DKTooltipWrapper> */}
                        {/* </div> */}
                      </>
                    )}
                    {!isAdmin &&
                      employeeDetails.user.isInCompleteProfile &&
                      employeeDetails.user.inCompleteFields &&
                      employeeDetails.user.inCompleteFields.length > 0 && (
                        <>
                          {/* <div>
                            <div className="column align-self-start">
                              {getIncompleteBadge()}
                            </div> */}
                          <div className="column align-self-start">
                            <DKTooltipWrapper
                              content={getIncompleteTooltipText(
                                employeeDetails.user.inCompleteFields
                              )}
                              tooltipClassName="warning-tooltip-prop warning-tooltip-prop "
                            >
                              <DKIcon
                                src={ic_info_message}
                                className="ml-s ic-s ml-r mt-xs cursor-hand "
                                style={{ opacity: 0.4 }}
                              />
                            </DKTooltipWrapper>
                          </div>
                        </>
                    )}
                    <div className="column align-self-start" style={{ marginLeft: "auto" }}>
                        <div className="row align-items-start mb-m">
                            {filteredOptions?.length > 0 && (
                                <div className="position-relative">
                                    {
                                        <DKButton
                                            title="..."
                                            className="bg-white fw-b fs-l"
                                            style={{ marginTop: "-11px" }}
                                            onClick={() => toggleAddNewList()}
                                        />
                                    }
                                    {hideListPicker && (
                                        <div
                                            className="transparent-background"
                                            onClick={() => hideAddNewList()}
                                        />
                                    )}
                                    {hideListPicker && getAddNewList()}
                                </div>
                            )}
                            {(employeeDetails.user.iamUserId === TenantService.get(TENANT.IAM_USER_ID) && !isAdmin ) && (
                                <DKButton
                                    title={"Manage Profile"}
                                    className={"dk-bg-button text-white fs-r"}
                                    onClick={() => {
                                        onEditEmployee();
                                    }}
                                />
                            )}
                        </div>
                    </div>
                  </div>
                  <div className="row align-items-start">
                    <div className="column mr-xxl">
                      <DKLabel
                        text={t(TenantService.get(TENANT.CUSTOM_FIELD_SECTION_ENABLED) ? "PW_BASIC_SALARY":"BASIC_SALARY")}
                        className="mb-s"
                      />
                      <DKLabel text={compensation} className="fw-m fs-b" />
                    </div>
                    <div className="column ml-xxl pl-xxl">
                      <DKLabel text="Employee Id" className="mb-s pl-l" />
                      <DKLabel
                        text={employeeDetails.user.employeeId}
                        className="fw-m mb-r pl-l"
                      />
                    </div>
                    {reportingManager &&
                        <div className="column ml-xxl pl-xxl">
                            <DKLabel text="Direct Manager Name" className="mb-s pl-l" />
                            <DKLabel
                                text={reportingManager}
                                className="fw-m mb-r pl-l"
                            />
                        </div>
                    }
                    {isShiftManagementEnabled && !Utility.isEmpty(shiftDetails) && !isModuleRestricted(moduleAccessControl, MODULE_ACCESS.SHIFT_MANAGEMENT) && (
                        <>
                            <div className="column ml-xxl pl-xxl">
                                <div className="row">
                                    <DKLabel text={`${t("ASSIGNED_SHIFT")} `} className="mb-r pl-l" />
                                    <div className="font-weight-12 fw-b text-app mb-r cursor-hand" onClick={() => { routeToShiftDetails(shiftDetails) }}>
                                        <u>
                                            {t("VIEW_DETAILS")}
                                        </u>
                                    </div>
                                </div>
                                <div className="row">
                                    <DKLabel
                                        text={`${shiftDetails.name} `}
                                        className="fw-m mb-r pl-l"
                                    />
                                    <div className="mb-r">
                                        {`(${ShiftUtils.convert24HrsTimeTo12Hrs(shiftDetails.from)} - ${ShiftUtils.convert24HrsTimeTo12Hrs(shiftDetails.to)})`}
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                  </div>
                </div>
              </div>
            );
        }
    }

    const getIsChartBlur= () =>{
        if(
            mask || 
            (
                isAdmin && 
                !PermissionUtils.hasAccess(MODULE.SALARY, [ACTION.VIEW, ACTION.EDIT])
            ) ||
            (
                !isAdmin && !TenantService.get(TENANT.IS_OWNER) && employeeDetails?.user?.iamUserId != TenantService.get(TENANT.IAM_USER_ID)
            )
        ) {
            return true
        } else {
            return false
        }
        
    }
    const getPayrunData = () => {
        let name = employeeDetails && employeeDetails.user ? `${employeeDetails.user.firstName} ${employeeDetails.user.lastName}` : ""
        let designation = employeeDetails && employeeDetails.user ? employeeDetails.user.designation : ""
        let deduction = (recentPayStubData['deductions'] ? recentPayStubData['deductions'] : 0) - (recentPayStubData['netTaxes'] ? recentPayStubData['netTaxes'] : 0)
        if (Utility.isEmpty(employeeDetails)) {
            return (<></>)
        }
        return (
            <div className="row parent-width row-responsive justify-content-between" style={{ filter: (recentPayStubData && recentPayStubData['basicPayrun']) ? "none" : "blur(2px)" }}>
                <div className="bg-white p-xl mt-l border-radius-m border-m column  web-width-70 web-max-width-70" style={{ minHeight: "234px" }}>
                    <div className="row pb-l align-items-start row-responsive" >
                        <div>
                            <DKLabel
                                text={name}
                                className="fw-m fs-m mb-r"
                            />
                        </div>
                        <div className="web-ml-auto">
                            <DKLabel
                                text={designation}
                                className="fw-m fs-m mb-r web-text-right"
                            />
                            {(recentPayStubData && recentPayStubData['workPeriod'])&&<DKLabel
                                text={`${Utility.formatDate(recentPayStubData['workPeriod']['from'], FORMAT.MMDDYYYY_2, "")} - ${Utility.formatDate(recentPayStubData['workPeriod']['to'], FORMAT.MMDDYYYY_2, "")}`}
                                className=" fs-m mb-r text-align-right"

                            />}
                        </div>
                    </div>
                    {recentPayStubData && (
                        <div className="row row-responsive justify-content-between" style={{ marginTop: "auto" }}>
                            <div style={{ width: "210px" }}>
                                <div className="row">

                                    <DKIcon src={DKIcons.ic_calendar} className="ic-s mr-r" />
                                    <DKLabel
                                        text={recentPayStubData['payDate'] ? Utility.formatDate(recentPayStubData['payDate'], FORMAT.YYYYMMDD, "") : ""}
                                        className="fs-m mb-r pt-s pr-l text-align-right"
                                    />
                                </div>
                                <div className="row fw-m fs-xl">
                                    { getMasked(mask,recentPayStubData['netPay'], employeeDetails?.user?.iamUserId) }
                                </div>
                            </div>
                            <div className="web-d-flex" >
                                <div>
                                    <DKLabel
                                        text={"Gross Pay"}
                                        className="fs-m mb-r pt-s web-text-right pr-l"
                                    />
                                    <div className="fw-m fs-xl pr-l">
                                        { getMasked(mask,(recentPayStubData['basicPayrun'] ? recentPayStubData['basicPayrun'] : 0) + (recentPayStubData['basicPayrun'] ? recentPayStubData['earnings'] : 0), employeeDetails?.user?.iamUserId) }
                                    </div>
                                </div>
                                <div>
                                    <DKLabel
                                        text={"Taxes"}
                                        className="fs-m mb-r pt-s web-text-right pr-l"
                                    />
                                    <div className="fw-m fs-xl pr-l">
                                    { getMasked(mask,recentPayStubData['netTaxes'], employeeDetails?.user?.iamUserId) }
                                    </div>
                                </div>
                                <div>
                                    <DKLabel
                                        text={"Deduction"}
                                        className="fs-m mb-r pt-s web-text-right"
                                    />
                                    <div className="fw-m fs-xl">
                                    { getMasked(mask,deduction, employeeDetails?.user?.iamUserId) }
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {false &&(
                        <div className="parent-width" style={{ marginTop: "auto" }}>
                            <div>
                                <div className="row">
                                    <DKIcon src={DKIcons.ic_calendar} className="ic-s mr-r" />
                                    <DKLabel
                                        text={recentPayStubData['payDate'] ? Utility.formatDate(recentPayStubData['payDate'], FORMAT.YYYYMMDD, "") : ""}
                                        className="fs-m mb-r pt-s pr-l web-text-right"
                                    />
                                </div>
                                <div className="row">
                                    <FormatCurrency className="fw-m fs-xl" amount={recentPayStubData['netPay'] ? recentPayStubData['netPay'] : 0} />
                                </div>
                            </div>
                            <div>
                                <div class="column align-items-end">
                                    <DKLabel
                                        text={"Gross Pay"}
                                        className="fs-m mb-r pt-s web-text-right"
                                    />
                                    <FormatCurrency className="fw-m fs-xl" amount={(recentPayStubData['basicPayrun'] ? recentPayStubData['basicPayrun'] : 0) + (recentPayStubData['basicPayrun'] ? recentPayStubData['earnings'] : 0)} />
                                </div>
                                <div class="column align-items-end">
                                    <DKLabel
                                        text={"Taxes"}
                                        className="fs-m mb-r pt-s web-text-right"
                                    />
                                    <FormatCurrency className="fw-m fs-xl" amount={recentPayStubData['netTaxes'] ? recentPayStubData['netTaxes'] : 0} />
                                </div>
                                <div class="column align-items-end">
                                    <DKLabel
                                        text={"Deduction"}
                                        className="fs-m mb-r pt-s text-align-right"
                                    />
                                    <FormatCurrency className="fw-m fs-xl" amount={deduction} />
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                <div className="bg-white p-xl mt-l border-radius-m border-m column web-width-30" style={{ minHeight: "220px", filter: getIsChartBlur() ? "blur(5px)" : "none" }}>
                    {(chartData.length > 0) && (
                        <PieChart
                            dataSet={chartData}
                            chartConfig={{
                                arcWidth: 0.7,
                                size: 180,
                                legendRenderer: (obj) => (<div className={"row width-auto flex-shrink-0 mt-s"}>
                                    <div
                                        style={{
                                            width: 4,
                                            height: 32,
                                            backgroundColor: obj.color,
                                            borderRadius: 3,
                                        }}
                                    />
                                    <div>
                                        <DKLabel text={PermissionUtils.showMaskedAmount(MaskInputUtil.getMaskedNumber(mask, obj.value))} className="ml-r fw-b" />
                                        <DKLabel text={obj.title} className="ml-r" />
                                    </div>
                                </div>),
                            }}
                            showLegend={true}
                        />
                    )}
                </div>
            </div>
        )
    }

    const getPayStubHeader = () => {
        return (
            <div className="row parent-wdth pl-l    " >
                <div className="column" style={{ width: "15%" }}>
                    <DKLabel
                        text={"Date"}
                        className="mb-r  pt-s pr-l text-align-right"
                    />
                </div>
                <div className="column" style={{ width: "15%" }}>
                    <DKLabel
                        text={"Pay Period"}
                        className="mb-r pt-s pr-l text-align-right"
                    />
                </div>
                <div className="column" style={{ width: "15%" }}>
                    <DKLabel
                        text={"Vendor"}
                        className="mb-r pt-s pr-l text-align-right"
                    />
                </div>
                <div className="column" style={{ width: "15%" }}>
                    <DKLabel
                        text={"Gross Pay"}
                        className="mb-r pt-s pr-l text-align-right"
                    />
                </div>
                <div className="column" style={{ width: "15%" }}>
                    <DKLabel
                        text={"Taxes"}
                        className="mb-r pt-s pr-l text-align-right"
                    />
                </div>
                <div className="column" style={{ width: "15%" }}>
                    <DKLabel
                        text={"Amount"}
                        className="mb-r pt-s pr-l text-align-right"
                    />
                </div>

            </div>)
    }

    const getPayStubRecord = () => {
        if (payStubData['paystubs'] && payStubData['paystubs'].length > 0) {
            return (
                payStubData['paystubs'].map((payStub, index) => {
                    return (
                        <div className="row parent-wdth pl-l" >
                            <div className="column" style={{ width: "15%" }}>
                                <DKLabel
                                    text={Utility.formatDate(payStub['payDate'], FORMAT.YYYYMMDD, "")}
                                    className="fw-m mb-r pt-s pr-l text-align-right"
                                />
                            </div>
                            <div className="column" style={{ width: "15%" }}>
                                <DKLabel
                                    text={payStub['compensationPeriod'] === "30" ? "Monthly" : "Yearly"}
                                    className="fw-m mb-r pt-s pr-l text-align-right"
                                />
                            </div>
                            <div className="column" style={{ width: "15%" }}>
                                <DKLabel
                                    text={""}
                                    className="mb-r pt-s pr-l text-align-right"
                                />
                            </div>
                            <div className="column" style={{ width: "15%" }}>
                                <DKLabel
                                    text={payStub['basicPayrun']}
                                    className="mb-r pt-s pr-l text-align-right"
                                />
                            </div>
                            <div className="column" style={{ width: "15%" }}>
                                <DKLabel
                                    text={payStub['netTaxes']}
                                    className="mb-r pt-s pr-l text-align-right"
                                />
                            </div>
                            <div className="column" style={{ width: "12%" }}>
                                <DKLabel
                                    text={payStub['netPay']}
                                    className="fw-m mb-r pt-s pr-l text-align-right"
                                />
                            </div>
                            <div className="column" style={{ width: "2%" }}>
                                <DKIcon
                                    className="ic-s mb-s cursor-hand"
                                    src={PDF_ICON}
                                    onClick={() => {
                                        downloadPayslip(payStub)
                                    }}
                                />
                            </div>

                        </div>
                    )
                })
            )
        }
    }

    const seeAllPaystub = () => {
        RouteManager.navigateToPage(
            PAGE_ROUTES.PAYSTUB_LIST,
            `id=${employeeDetails["user"].userId}&isContractor=${false}`
        );
    }

    const getFilename = (url) => {
        return url.substring(url.indexOf("_") + 1, url.length);
    }

    const downloadPayslip = (paystub) => {
        if (paystub['filepath']) {
            showLoader("Downloading attachment... Please wait");
            AttachmentService.getPresignedURL(paystub['filepath']).then((response) => {
                AttachmentService.downloadFile(response).then((response) => {
                    removeLoader();
                    saveAs(response, getFilename(paystub['filepath']));
                }, (error) => {
                    removeLoader()
                })
            })
        } else {
            AttachmentService.downloadPaystubPDF(paystub._id).then((response) => {
                removeLoader();
                saveAs(response, getFilename(paystub['filepath']));
            }, (error) => {
                removeLoader()
            })
        }
    }

    const getComponentData = () => {
        let data = []
        if (componentMeta.components && employeeDetails.user && employeeDetails.user.components.length > 0) {
            employeeDetails.user.components.forEach(empComp => {
                let comp = componentMeta.components.filter((x) => x.id === empComp.componentId);
                if (comp.length > 0) {
                    let compObj = {
                        name: comp[0].name,
                        type: comp[0].type === "DEDUCTION" ? "Deduction" : "Earning",
                        isActive: comp[0].isActive
                    }
                    data.push(compObj)
                }
            })
        }

        if (benefitsMeta.benefits && employeeDetails.user && employeeDetails.user.benefits.length > 0) {
            employeeDetails.user.benefits.forEach(empBenefit => {
                let benefit = benefitsMeta.benefits.filter((x) => x.benefitId === empBenefit.benefitId);
                if (benefit.length > 0) {
                    let benefitObj = {
                        name: benefit[0].name,
                        type: "Benefit",
                        isActive: benefit[0].isActive
                    }
                    data.push(benefitObj)
                }
            })
        }
        return data

    }

    const getComponentsCard = () => {
        const compoData = getComponentData()
        return (
            <>
                {(employeeDetails.user && (employeeDetails.user.components.length > 0 || employeeDetails.user.benefits.length > 0)) &&
                    < >
                        {compoData.map((obj, index) => {
                            return (
                                <div className=" mt-l row  parent-width">
                                    <div className="column" style={{ minWidth: "85px" }}>
                                        {getCompBenefitLabel(obj)}
                                    </div>
                                    <div className="column ml-s" style={{ width: "65%" }}>
                                        <DKLabel text={obj.name} className="ml-r mr-s" />
                                    </div>
                                    <div className="column" style={{ display: "contents", width: "10%" }}>
                                        <DKCheckMark isSelected={obj.isActive} color="bg-app" /><DKLabel className="ml-s" text={obj.isActive ? "Active" : "Inactive"} />

                                    </div>

                                </div>
                            )
                        })
                        }
                    </>
                }
            </>
        )
    }

    const getAddEmployeeCard = () => {
        return (
            < >
                {(employeeDetails.user && employeeDetails.user.benefits.length == 0 && employeeDetails.user.components.length == 0) &&
                    <div style={{ margin: "auto" }}>
                        <DKLabel text={isAdmin ? t('NO_COMPONENTS_VIEW_ADMIN'):t('NO_COMPONENTS_VIEW_EMPLOYEE')} className="m-auto fw-m" />
                        {<div className="mt-l" style={{ width: "107px", marginLeft: "30%" }}>
                            {(TenantService.get(TENANT.IS_OWNER) ||
                            PermissionUtils.hasAccess(MODULE.EMPLOYEE, [ACTION.EDIT]) ||
                            (!isAdmin && employeeDetails.user.iamUserId === TenantService.get(TENANT.IAM_USER_ID))) && <DKButton
                                title="Edit Employee"
                                className=" bg-app border-m text-white"
                                onClick={() => {
                                    onEditEmployee()
                                }}
                            />}
                        </div>}
                    </div>
                }
            </>
        )
    }

    const showPaystubCompBenefit = () => {
        return (
            <div className="row parent-width row-responsive align-items-start justify-content-between">
                {!isMobileWebView() && !isModuleRestricted(moduleAccessControl, MODULE_ACCESS.PAYSTUB) && <div className="bg-white p-xl mt-l border-radius-m border-m column web-width-70 web-max-width-70" style={{ minHeight: "365px" }}>
                    <div className="row parent-width">
                        {/* <div style={{ width: "165px" }}>
                            <DKLabel text={"Recent Paystubs"} className="ml-r fw-b fs-l" />
                        </div> */}
                        {(payStubData['filterResponse'] && payStubData['filterResponse'].totalCount > 5) && <div className="row-reverse" style={{ marginBottom: "-34px", zIndex: 5 }}>
                            <DKButton
                                title="See All"
                                className="bg-white fw-b fs-l "
                                onClick={() => {
                                    seeAllPaystub()
                                }}
                            />
                        </div>}
                    </div>
                    {/* {getPayStubHeader()}
                    {getPayStubRecord()} */}
                    <div className="parent-width" style={{ overflowX: "hidden", minHeight: "314px", overflowY: "hidden" }}>
                        {employeeDetails["user"] && <PayStubList id={employeeDetails["user"].userId} recent={true} mask={mask } />}
                    </div>
                </div>}
                <div className="bg-white p-xl mt-l border-radius-m border-m column web-width-30" style={{ minHeight: "365px" }}>
                    <DKLabel text={t("COMPONENTS")} className=" fw-b fs-l mb-xl border-box" />
                    {getComponentsCard()}
                    {/* {getBenefitssCard()} */}
                    {getAddEmployeeCard()}
                </div>
            </div>
        )
    }

    const getManagerCard = () => {
        return(
            <div className="bg-white p-xl mt-l border-radius-m border-m column web-width-70 web-max-width-70 position-relative" style={{minHeight:365}}>
                <DKLabel className="fw-m fs-l" text="Team Attendance"/>
                <TeamAttendanceCard/>
            </div>
        )
    }

    return (
        <div className={`parent-width ${props.accessedBy === EMPLOYEE ? 'mt-l' : ''}`}>
            {props.accessedBy === EMPLOYEE && !isMobileWebView() && <SetupDetails className="mb-l" {...props} />}
            {getEmployeeDetails()}
            {!isModuleRestricted(moduleAccessControl, MODULE_ACCESS.PAYSTUB) && getPayrunData()}
            {showPaystubCompBenefit()}
            {isManager && props.accessedBy === EMPLOYEE && getManagerCard()}
            {isTerminateEmployee && (
                <div>
                    <TerminationPortal
                        module={TABLES.EMPLOYEE_TERMINATION}
                        origin={PAGE_ROUTES.EMPLOYEE_LIST}
                        id={employeeDetails["user"].userId}
                        step="0"
                        close={onTerminateEmployeeClose}
                        loadEmployee={loadEmployee}
                    />
                </div>
            )}
        </div>
    )
}

export default ViewEmployee
